import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../../consts';
import InputSelect from '../../components/inputs/InputSelect';
import { toast } from 'react-toastify';
import { withTheme } from 'styled-components';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import { Grid } from '@material-ui/core';

let FORM_INITIAL_STATE = {
  dreOptions: null,
  municipioOption: null,
  escolaOptions: null,
  ano: null,
  periodo: null,
  disciplinaOptions: null
};

const FiltersPageRelatorio = ({ buttonRelatorio, ...props }) => {
  const { setStateFilters } = useContext(FilterRelatorioContext);
  const [state, setState] = useState({
    me: null,
    loading: false,
    isLoading: false,
    isPlaceholder: 'Selecione',
  });
  const [formApi, setFormApi] = useState({});
  const [formInputData, setFormInputData] = useState({});

  const performUpdate = (newData) => {
    setFormInputData((prevState) => ({ ...prevState, ...newData }))
  }

  const groups =
    state.me &&
    state.me.logged_group.map((f) => {
      return f.toUpperCase();
    });

  const host = window.location.host
  const legenda = 'Rede de Ensino';
  const restrictAcess = groups && groups.includes('ADMINISTRADOR') || groups && groups.includes('DRE');

  FORM_INITIAL_STATE = restrictAcess ? FORM_INITIAL_STATE : {
    dreOptions: null,
    escolaOptions: null,
    ano: null,
    periodo: null,
    disciplinaOptions: null
  };

  const fetchMunicipio = (dreId) => {
    if (dreId) {
      performUpdate({
        dreData: {
          dreId: dreId.id,
          dreNome: dreId.value
        },
        dreId: dreId.id,
      })
      axios
        .get(`${API_HOST}/avalia/municipio?dre_id=${dreId.id}`)
        .then((res) => {
          if (res.data.results.length === 0) {
            throw new Error('Nenhum município encontrado');
          }
          performUpdate({
            municipioOption: res && res.data.results.map((d) => ({
              value: d.cd_municipio,
              label: d.nm_municipio,
              ...d
            }))
          })
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  const fetchEscola = (municipio) => {
    if (municipio) {
      const params = {
        cd_municipio: municipio.value,
        dre: municipio.dre_id
      }
      axios
        .get(`${API_HOST}/avalia/escola`, { params })
        .then((res) => {
          if (res.data.length === 0) {
            throw new Error('Nenhuma escola encontrada');
          }
          performUpdate({
            escolaOptions: res && res.data.map((d) => ({
              value: d.cd_escola,
              label: d.nm_escola,
              ...d
            })),
            municipio: municipio.value
          })
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  const fetchEtapaEscola = (cdEscola) => {
    if (cdEscola) {
      axios
        .get(`${API_HOST}/avalia/escola_etapa?cd_escola=${cdEscola.value}`)
        .then((res) => {
          performUpdate({
            etapaOption: res && res.data.results.map((d) => ({
              value: d.nr_etapa,
              label: d.dc_etapa,
              ...d
            }))
          })
        })
        .catch((err) => { });
    }
  };

  const fetchAno = () => {
    axios
      .get(`${API_HOST}/avalia/ano`)
      .then((res) => {
        performUpdate({
          anoOptions: res.data.map((d) => ({
            value: d.id,
            label: d.ds_ano
          }))
        })
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchPeriodo = () => {
    axios
      .get(`${API_HOST}/avalia/periodo`)
      .then((res) => {
        performUpdate({
          periodoOptions: res && res.data.map((d) => ({
            value: d.id,
            label: d.ds_periodo
          }))
        })
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchAnoPeriodo = async (prova, ano) => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/periodo_ano?periodo__id=${prova}&ano__id=${ano}`);
      if (response.data.length > 0) {
        performUpdate({ periodoAno: response.data[0].id });
      } else {
        console.error('Nenhum período de ano encontrado');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDres = (me) => {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/core/rede_dre_inst/${me}/get_dres`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((res) => {
        performUpdate({
          dres: res.data.dre.map((d) => ({
            id: d.cd_dre,
            value: d.ds_dre,
            label: d.ds_dre,
            ...d
          }))
        })
      })
      .catch((response) => toast.error(response.error));
  }

  const fetchDresAdm = () => {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/avalia/dre`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((res) => {
        performUpdate({
          dres: res.data.map((d) => ({
            ...d,
            id: d.external_id,
            value: d.dre_name,
            label: d.dre_name,
          }))
        })
      })
      .catch((response) => toast.error(response.error));
  };

  const fetchInstitution = async (me, dre) => {
    performUpdate({
      dreData: {
        dreId: dre.id,
        dreNome: dre.value
      },
      dreId: dre.id,
    })
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(
        `${API_HOST}/core/rede_dre_inst/get_escolas?user_group_instituicao__usuario=${me}&dre__cd_dre=${dre.id}`,
        {
          headers: {
            Authorization: `JWT ${token}`
          }
        }
      );
      if (response.data.length === 0) {
        throw new Error('Nenhuma escola encontrada');
      }
      performUpdate({
        escolaOptions: response.data.map((x) => ({
          value: x.instituicao.instituicao.codigo,
          label: x.instituicao.instituicao.descricao,
          ...x,
        }))
      });
    } catch (error) {
      setState(prevState => ({ ...prevState, isLoading: false }));
      toast.error("Nenhuma escola encontrada");
      console.error(error.message);
    }
  }

  const fetchMe = () => {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        setState(prevState => ({ ...prevState, me: response.data }));
        let groups = response.data.logged_group.map((f) => {
          return f.toUpperCase();
        });
        if (groups.includes('ADMINISTRADOR')) {
          fetchDresAdm();
        } else {
          fetchDres(response.data.id);
        }
      })
      .catch((response) => toast.error(response.error));
  }

  const fetchDisciplinas = (disciplina) => {
    axios
      .get(`${API_HOST}/avalia/disciplina`)
      .then((res) => {
          performUpdate({
          disciplinaOptions: res.data.results.map((d) => ({
            value: d.id,
            label: d.disciplina,
            ...d
          })),
          cd_turma: disciplina.cd_turma,
          currentEscola: disciplina.value
        })
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const submitForm = (e) => {
    e.preventDefault()
    let isValidForm = true;
    let formValues = formApi.getState().values;
    Object.keys(formValues).forEach((key) => {
      if (validateField(formValues[key])) {
        formApi.setError(key, ['O campo é obrigatório']);
        isValidForm = false;
      }
    });
    if (isValidForm) {
      setStateFilters({ ...formInputData, isFormSubmit: true });
    }
  }

  const validateField = fieldValue => {
    if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
      return true;
    }
  };

  useEffect(() => {
    fetchAno();
    fetchMe();
  }, []);

  return (
    <>
      <div>
        <Form
          getApi={(formApi) => {
            setFormApi((prevState) => ({ ...prevState, ...formApi }));
          }}
          initialValues={FORM_INITIAL_STATE}
        >
          <Grid
            container xs={12}
            style={{
              ...(!restrictAcess && { justifyContent: 'flex-start' })
            }}>
            <Grid item xs={12} md={3}>
              <InputSelect
                key='dreOptions-select'
                label={legenda}
                field='dreOptions'
                onChange={(e) => {
                  if (restrictAcess) {
                    formApi.setValue('municipioOption', '');
                    fetchMunicipio(e)
                  } else {
                    formApi.setValue('escolaOptions', '');
                    fetchInstitution(state.me.id, e);
                  }
                }}
                options={formInputData.dres}
                required={true}
              />
            </Grid>

            {restrictAcess &&
              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'municipioOption-select'}
                  label='Município'
                  field='municipioOption'
                  onChange={(e) => {
                    formApi.setValue('escolaOptions', '');
                    fetchEscola(e)
                  }}
                  options={formInputData.municipioOption}
                  required={true}
                />
              </Grid>}

            <Grid item xs={12} md={6}>
              <InputSelect
                key={'escolaOptions-select'}
                label='Escola'
                field='escolaOptions'
                onChange={(e) => {
                  formApi.setValue('ano', '');
                  formApi.setValue('disciplinaOptions', '');
                  if (e) {
                    fetchDisciplinas(e);
                    fetchEtapaEscola(e);
                    performUpdate({ escolaId: e.id })
                  }
                }}
                options={formInputData.escolaOptions}
                required={true}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <InputSelect
                key={'ano-select'}
                label='Ano'
                field='ano'
                onChange={(e) => {
                  formApi.setValue('periodo', '');
                  if (e) {
                    fetchPeriodo();
                    performUpdate({ ano: e.value });
                  }
                }}
                options={formInputData.anoOptions}
                required={true}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <InputSelect
                key={'periodo-select'}
                isLoading={state.isLoading}
                label='Avaliação'
                field='periodo'
                onChange={(e) => {
                  if (e) {
                    fetchAnoPeriodo(e.value, formInputData.ano);
                    performUpdate({ periodoAno: e.value });
                  }
                }}
                options={formInputData.periodoOptions}
                required={true}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <InputSelect
                key={'disciplinaOptions-select'}
                isLoading={state.isLoading}
                label='Área do Conhecimento'
                field='disciplinaOptions'
                onChange={(e) => {
                  if (e) {
                    fetchAno();
                    performUpdate({ DisciplinaID: e.value });
                  }
                }}
                options={formInputData.disciplinaOptions}
                required={true}
              />
            </Grid>

            <Grid
              item xs={12} md={3}
              style={{
                display: 'flex',
                alignItems: 'center',
                ...(!restrictAcess && {
                  justifyContent: 'end',
                  padding: '5px'
                })
              }}>
              <button
                style={{
                  color: 'white',
                  backgroundColor: props.theme.primary,
                  border: 'none',
                  fontSize: '16px',
                  fontWeight: '600',
                  textAlign: 'center',
                  cursor: 'pointer',
                  borderRadius: '15px',
                  boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                  letterSpacing: '1px',
                  padding: '4px 16px',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginLeft: '10px',
                }}
                onClick={(e) => { submitForm(e) }}
              >
                Gerar Relatório
              </button>
            </Grid>
          </Grid>
        </Form>
      </div>
    </>
  );
}

FiltersPageRelatorio.contextType = FilterRelatorioContext;
export default withTheme(FiltersPageRelatorio);
